import { IonicModule } from "@ionic/angular";
import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ListOfferPage } from "./list-offer.page";

import { SearchPageModule } from "../search/search.module";
import { DetailsPageModule } from "../details/details.module";

import { NgIdleModule } from "@ng-idle/core";
import { ComponentsModule } from "src/app/components/components.module";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    SearchPageModule,
    ComponentsModule,
    DetailsPageModule,
    RouterModule.forChild([{ path: "", component: ListOfferPage }]),
    NgIdleModule.forRoot(),
  ],
  declarations: [ListOfferPage],
})
export class ListOfferModule {}
